import {
  createStore,
  combineReducers,
  applyMiddleware,
} from 'redux';
import thunk from 'redux-thunk';

import user from './user/reducers';
import quiz from './quiz/reducers';
import category from './category/reducers';
import subcategory from './subcategory/reducers';
import question from './question/reducers';
import result from './result/reducers';
import pending from './pending/reducers';
import alert from './alert/reducers';
import extra from './extra/reducers';
import leaderboard from './leaderboard/reducers';
import notification from './notification/reducers';
import badge from './badge/reducers';
import modal from './modal/reducers';
import preferences from './preferences/reducers';

const rootReducer = combineReducers({
  user,
  quiz,
  category,
  subcategory,
  question,
  result,
  alert,
  pending,
  extra,
  leaderboard,
  notification,
  badge,
  modal,
  preferences,
});

const middleWare = [thunk];

export default (preloadedState = {}, customMiddleware = []) => createStore(
  rootReducer,
  preloadedState,
  applyMiddleware(...middleWare, ...customMiddleware),
);
